import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FooterBox,
  FooterBoxBottom,
  FooterBoxSection,
  FooterBoxSectionImage,
  FooterBoxSectionLink,
  FooterBoxSectionList,
  FooterBoxSectionListIcon,
  FooterBoxSectionListLink,
  FooterBoxSectionSlogan,
  FooterBoxSectionSocials,
  FooterBoxSectionTitle,
  FooterContainer,
  FooterLine,
} from "./FooterStyles";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <FooterContainer>
      <FooterBox>
        <FooterBoxSection>
          <FooterBoxSectionImage
            src="/assets/logo_inv.png"
            alt="Smart Personeel"
          />
          <FooterBoxSectionSlogan>
            Better Work, Better Life!
          </FooterBoxSectionSlogan>
          <FooterBoxSectionSocials>
            <a
              href="https://www.facebook.com/people/Smart-Personeel/61571583845077/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faFacebook}
                style={{ marginRight: "30px", color: "#3393F0" }}
              />
            </a>
            <a
              href="https://www.instagram.com/smartpersoneel/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faInstagram}
                style={{ marginRight: "30px", color: "#3393F0" }}
              />
            </a>
            <a
              href="https://www.linkedin.com/company/smart-personeel"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedin} style={{ color: "#3393F0" }} />
            </a>
          </FooterBoxSectionSocials>
        </FooterBoxSection>
        <FooterLine />
        <FooterBoxSection>
          <FooterBoxSectionTitle>Smart Personeel</FooterBoxSectionTitle>
          <FooterBoxSectionList>
            <Link
              to="/about"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FooterBoxSectionListLink>Over Smart</FooterBoxSectionListLink>
            </Link>
            <Link
              to="/commissioners/flex"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FooterBoxSectionListLink>Smart Flex</FooterBoxSectionListLink>
            </Link>
            <Link
              to="/commissioners/crisis"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FooterBoxSectionListLink>
                Smart Crisis Team
              </FooterBoxSectionListLink>
            </Link>
            <Link
              to="/commissioners/planning"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FooterBoxSectionListLink>
                Smart Planners
              </FooterBoxSectionListLink>
            </Link>
          </FooterBoxSectionList>
        </FooterBoxSection>
        <FooterBoxSection>
          <FooterBoxSectionTitle>Support</FooterBoxSectionTitle>
          <FooterBoxSectionList>
            <Link
              to="/healthcare/work"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FooterBoxSectionListLink>
                Werken bij Smart
              </FooterBoxSectionListLink>
            </Link>
            <Link
              to="/healthcare/vacancy"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FooterBoxSectionListLink>Vacatures</FooterBoxSectionListLink>
            </Link>
            <Link
              to="https://mijn.smart-personeel.nl/home"
              target="_blank"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FooterBoxSectionListLink>
                Mijn Smart App
              </FooterBoxSectionListLink>
            </Link>
            <Link
              to="/contact"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FooterBoxSectionListLink>Contact</FooterBoxSectionListLink>
            </Link>
            <Link
              to="/admin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FooterBoxSectionListLink>Beheer</FooterBoxSectionListLink>
            </Link>
          </FooterBoxSectionList>
        </FooterBoxSection>
        <FooterBoxSection>
          <FooterBoxSectionTitle>Contact Info</FooterBoxSectionTitle>
          <FooterBoxSectionList>
            <li>
              <FooterBoxSectionListIcon icon={faLocationDot} /> Kerkenbos 1307C
              - 6546 BG, Nijmegen
            </li>
            <li>
              <a
                href="mailto:info@smart-personeel.nl"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <FooterBoxSectionListIcon icon={faEnvelope} />{" "}
                info@smart-personeel.nl
              </a>
            </li>
            <li>
              <FooterBoxSectionLink href="tel:+31850607774">
                <FooterBoxSectionListIcon icon={faPhone} />
                +31850607774
              </FooterBoxSectionLink>
            </li>
            <li>
              <FooterBoxSectionListIcon icon={faLocationDot} /> Maandag -
              Vrijdag 09:00 - 17:00
            </li>
          </FooterBoxSectionList>
        </FooterBoxSection>
        <FooterLine />
        <FooterBoxBottom>
          <span>
            <Link
              to="/terms"
              style={{
                textDecoration: "none",
                color: "white",
                marginLeft: "5px",
              }}
            >
              Algemene Voorwaarden
            </Link>{" "}
            -
            <Link
              to="/privacy"
              style={{
                textDecoration: "none",
                color: "white",
                marginLeft: "5px",
              }}
            >
              Privacy en Cookie Policy
            </Link>
          </span>
          Copyright © 2025 Smart-personeel B.V.
        </FooterBoxBottom>
      </FooterBox>
    </FooterContainer>
  );
}

export default Footer;
